/**
 * @generated SignedSource<<82f0f3f1644d31186dc98cf28e411765>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksLiveArticleLiveArticle$data = {
  readonly liveContents: ReadonlyArray<{
    readonly customTime: number | null;
    readonly entityId: string | null;
    readonly entityUuid: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"itemLiveArticleContentLiveContent" | "itemLiveArticleTimelineLiveContent">;
  } | null> | null;
  readonly " $fragmentType": "hooksLiveArticleLiveArticle";
};
export type hooksLiveArticleLiveArticle$key = {
  readonly " $data"?: hooksLiveArticleLiveArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksLiveArticleLiveArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksLiveArticleLiveArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LiveContent",
      "kind": "LinkedField",
      "name": "liveContents",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityUuid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "itemLiveArticleContentLiveContent"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "itemLiveArticleTimelineLiveContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LiveArticle",
  "abstractKey": null
};

(node as any).hash = "997c98fec20c98179d96b80653a9cbab";

export default node;
